module.exports = __webpack_public_path__ + "static/media/绿舟之家.baf0ca6f.jpg";